<template>
  <SubContent @back="$router.go(-1)">
    <template v-slot:nav_left>
      全部比赛报告
    </template>
    <template v-slot:content_right>
      <div class="mainTrainingContent">
        <yioks-loading v-if="loading"></yioks-loading>
        <template v-else>
          <yioks-empty v-if="empty" />
          <div   v-else class="train_list_wrap" >
            <div  class="table">
              <div class="thead">
                <div class="tr">
                  <div class="th name"><strong>比赛报告</strong></div>
                  <div class="th startTime"><strong>开始时间</strong></div>
                  <div class="th position"><strong>位置</strong></div>
                  <div class="th coachName"><strong>主教练</strong></div>
                </div>
              </div>
              <div class="scrollArea">
                <vue-scroll >
                  <div class="tbodyWrap">
                    <div class="tbody">
                      <div
                        v-for="(item, index) in mediaList"
                        :key="index"
                        class="tr">
                        <div class="trH">
                          <div class="td name">
                            <p>{{ item.trainingName || '--' }}</p>
                          </div>
                          <div class="td startTime">
                            <p>{{ item.trainingTime | time  }}</p>
                          </div>
                          <div class="td position">
                            <p>{{ item.positionId | positionStatus }}</p>
                          </div>
                          <div class="td coachName">
                            <p>{{item.chiefCoachName}}</p>
                          </div>
                        </div>
                        <div class="info">
                          <div class="score rowLine">
                            <p style="display: flex;justify-content: space-between;width: 100%;padding: 0 15px">
                              <span > 技术： {{item.technicalScore}}分</span>
                              <span> 战术： {{item.tacticalScore}}分</span>
                              <span> 体能： {{item.physicalScore}}分</span>
                              <span> 心理： {{item.psychologicalScore}}分</span>
                            </p>
                          </div>
                          <div class="time rowLine">
                            比赛时长：{{parseInt((item.trainingTotalTime  * item.attendance / 100)  / 60 )}} 小时 {{parseInt((item.trainingTotalTime * item.attendance / 100 ) % 60 )}}分钟
                          </div>
                          <div class="goals rowLine">
                            <p >比赛目标：{{item.learningObjectives || '--'}}</p>
                          </div>
                          <div class="comment rowLine">
                            <p>总体评价：{{item.generalEvalComments || '--'}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </div>
        </template>
      </div>
      <Pagination :total="total" :page.sync="page"/>
    </template>
  </SubContent>
</template>

<script>
import teaching from '@/api/teaching'
import playImg from '@/assets/images/common/playImg.png'
import planImg from '@/assets/images/common/plan_default.png'
import { positionStatus } from '@/utils/yioks_filter'
export default {
  name: 'More',
  components: {
    'SubContent': () => import('@/components/layout/list'),
    'Pagination': () => import('@/components/Pagination')
  },
  filters: {
    positionStatus
  },
  data () {
    return {
      playImg,
      planImg,
      playerUuid: this.$route.query.uuid,
      mediaList: [],
      page: 0,
      pageSize: 20,
      total: 0,
      empty: false,
      loading: false,
    }
  },
  created () {
    this.getMediaList()
  },
  methods: {
    getMediaList () {
      this.loading = true
      teaching.matchTrainListToPlayer({ page: this.page, size: this.pageSize, playerUuid: this.playerUuid }).then(res => {
        this.loading = false
        if (res.content.length === 0) {
          this.empty = true
        } else {
          this.empty = false
          this.total = res.totalElements
          this.mediaList = res.content
        }
      }).catch(err=>{
        this.loading = false
      })
    },
    filterTime (val) {
      if (val === 0) {
        return '00'
      }
      if (String(val).length < 2) {
        return '0' + String(val)
      } else {
        return val
      }
    },
    goDetail (uuid) {
      this.$router.push({
        path: '/media/detail',
        query: {
          uuid
        }
      })
    },
  }
}
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable'
  .mainTrainingContent
    height 570px
    .train_list_wrap
      margin-top 40px
      flex 1
      overflow hidden
      .table {
        display flex
        flex-direction column
        flex 1
        width: 100%;
        // margin: 30px 0 0;
        .thead {
          border: 1px solid $color_white;
          /*border-bottom  none*/
        }
        .thead {
          margin: 0 40px;
          .tr {
            height: 45px;
            display: flex;
          }
        }
        .scrollArea {
          height: 470px;
          padding-bottom 15px
          /*flex 1 */
          /*overflow hidden*/
        }
        .tbodyWrap {
          display block
          // padding: 0 40px;
        }
        .tbody {
          display block
          width 810px
          margin-left auto
          margin-right auto
          max-width: 810px;
          border-top: none;
          border-bottom: none;
          .tr{
            border  1px solid white
            margin-bottom 20px
            &:first-child{
              border-top none
            }
          }
          .trH {
            height: 49px;
            display: flex;
            border-bottom: 1px solid $color_white;
            flex-wrap wrap
          }
          .info{
            .rowLine{
              min-height 49px
              display flex
              align-items center
              border-bottom 1px solid white
              &:last-child{
                border-bottom none
              }
            }
            .goals,.comment,.time {
              padding 5px
            }
          }
        }
        .th, .td {
          height: 100%;
          /*flex: 1 1 auto;*/
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: $font_size_medium;
          border-right: 1px solid $color_white;
        }
        .th:last-child, .td:last-child {
          border-right: none;
        }
        .td {
          p {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: $color_white;
          }
        }
        .startTime{
          width 20%
        }
        .name{
          width 35%
        }
        .coachName{
          width: 25%;
        }
        .position{
          width: 20%
        }
      }
</style>
